// --------------------------------------------------------------
// Created On: 2025-05-27
// Author: Dimitra Weinstein
//
// Last Modified: 2025-11-06
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React, { Fragment } from "react";
import Modal from "../../../components/Modal/Modal";
import ModalHeader from "../../../components/ModalHeader/ModalHeader";
import ModalBody from "../../../components/ModalBody/ModalBody";
import ModalFooter from "../../../components/ModalFooter/ModalFooter";
import styles from "./ImportCsvInfoModal.module.scss";

// Modal for showing generic information.
export default function ImportCsvInfoModal(props: Props): Component {
  return (
    <Fragment>
      <span className={props.darkBackground ? styles.linkBright : styles.link} onClick={props.onClick}>
        {props.linkMessage !== undefined && props.linkMessage !== null && props.linkMessage.length !== 0 ? (
          <span>{props.linkMessage}</span>
        ) : (
          <span>&#40; ? &#41;</span>
        )}
      </span>

      <Modal
        show={props.showModal}
        onHide={() => props.onClose()}
        backdropClassName={`${styles.modal} ${styles.backdrop}`}
        style={{ zIndex: "var(--super-modal-z-index)" }}
        size="xl"
        animation
        centered
      >
        <ModalHeader>
          <h5 className="font-weight-bold">{props.title}</h5>
        </ModalHeader>

        <ModalBody>{props.children}</ModalBody>

        <ModalFooter>
          <a href="/import_parts_template.csv" download="import_parts_template">
            <button data-test="download-template-button" className="btn btn-primary">
              Download Template
            </button>
          </a>
          <button className="btn btn-secondary" type="button" onClick={() => props.onClose()}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

interface Props {
  showModal: boolean;
  title: string;
  linkMessage?: string;
  darkBackground: boolean;
  onClick: () => void;
  onClose: () => void;
  children: Component | Component[];
}
